import React, { useEffect, useContext, useCallback } from "react";

import GlobalContext from "contexts/context";
import DatabaseContext from "data/contextDatabase";

// import firebase from "firebase-messaging";
// import { messaging } from "push/init-fcm";

const get_browser = () => {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: "Opera", version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
  };
};

const isSafari = get_browser().name === "Safari";

if ("serviceWorker" in navigator && !isSafari) {
  // window.addEventListener("load", () => {
  navigator.serviceWorker
    .register("./firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Registration successful, scope is:", registration.scope);
    })
    .catch((err) => {
      console.log("Service worker registration failed, error:", err);
    });
  // });
}

const FCM = (props) => {
  const { globalState } = useContext(GlobalContext);
  const { databaseState, databaseDispatch } = useContext(DatabaseContext);

  const randomString = (length) => {
    let result = "";
    let characters =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  const wssToken = useCallback(
    (muid, cid, token) => {
      let d = new Date();
      let ts_sender =
        d.getFullYear() +
        "-" +
        ("0" + (d.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + d.getDate()).slice(-2) +
        " " +
        ("0" + d.getHours()).slice(-2) +
        ":" +
        ("0" + d.getMinutes()).slice(-2) +
        ":" +
        ("0" + d.getSeconds()).slice(-2);
      let j = {
        type: "w.user.token.update",
        muid: muid,
        cid: cid,
        fcmtoken: token,
        version: globalState.version,
        txn_id: "null",
        ts_sender: ts_sender,
        smid: "fcm_smid", // randomString(8),
      };
      databaseState.dbMaster &&
        databaseDispatch({
          type: "UPSERT_REC",
          values: {
            jmessage: j,
            db: databaseState.dbMaster,
            collection: "send",
            table: "confirm_smid",
            rowid: j.smid,
            doc: j,
          },
        });
    },
    [databaseDispatch, databaseState.dbMaster, globalState.version]
  );

  useEffect(() => {
    navigator.permissions &&
      navigator.permissions.query({ name: "notifications" }).then((res) => {
        res.onchange = (e) => {
          // detecting if the event is a change
          if (e.type === "change") {
            // checking what the new permissionStatus state is
            const newState = e.target.state;
            if (newState === "denied") {
              console.log("why did you decide to block notifications?");
            } else if (newState === "granted") {
              console.log("We will keep in touch!");
            } else {
              console.log("Thanks for reverting things back to normal");
            }
          }
        };
      });

    // messaging
    //   .requestPermission()
    //   .then(async function () {
    //     const token = await messaging.getToken();
    //     console.log("FCM token: ", token);
    //   })
    //   .catch(function (err) {
    //     console.log("Unable to get permission to notify.", err);
    //   });

    !isSafari &&
      import("push/init-fcm")
        .then((module) => {
          module.messaging
            .getToken()
            .then((currentToken) => {
              if (currentToken) {
                console.log("FCM token: ", currentToken);
                // sendTokenToServer(currentToken);
                wssToken(globalState.muid, globalState.cid, currentToken);
                // updateUIForPushEnabled(currentToken);
              } else {
                // Show permission request.
                console.log(
                  "No Instance ID token available. Request permission to generate one."
                );
                // Show permission UI.

                console.log("Please allow FCM token");
                // updateUIForPushPermissionRequired();
                // setTokenSentToServer(false);
              }
            })
            .catch((err) => {
              console.log("An error occurred while retrieving token. ", err);
              // showToken('Error retrieving Instance ID token. ', err);
              // setTokenSentToServer(false);
            });
        })
        .catch((err) => {});

    return () => {
      console.log("App component runs componentWillUnmount for the last time");
    };
  }, [globalState.muid, globalState.cid, wssToken]);

  useEffect(() => {
    // if FCM changes, send to server with UID

    return () => {};
  }, []);

  let content = <div></div>;
  return content;
};

export default React.memo(FCM, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
